import { Toast } from '../../../core/ui/toast.service';
import { Modal } from '../../../core/ui/dialogs/modal.service';
import { ConfirmModalComponent } from '../../../core/ui/confirm-modal/confirm-modal.component';
import { AppHttpClient } from '../../../core/http/app-http-client.service';
import * as i0 from "@angular/core";
import * as i1 from "../../../core/http/app-http-client.service";
import * as i2 from "../../../core/ui/toast.service";
import * as i3 from "../../../core/ui/dialogs/modal.service";
var AppearancePendingChanges = /** @class */ (function () {
    function AppearancePendingChanges(http, toast, modal) {
        this.http = http;
        this.toast = toast;
        this.modal = modal;
        /**
         * Changes that are yet to be saved to backend.
         */
        this.changes = {};
    }
    /**
     * Add a new change to the store.
     */
    AppearancePendingChanges.prototype.add = function (name, value) {
        this.changes[name] = value;
    };
    /**
     * Save pending changes to backend.
     */
    AppearancePendingChanges.prototype.save = function () {
        var _this = this;
        this.saveChanges(this.changes).subscribe(function () {
            _this.changes = {};
            _this.toast.open('Appearance saved');
        });
    };
    AppearancePendingChanges.prototype.saveChanges = function (changes) {
        return this.http.post('admin/appearance', changes);
    };
    /**
     * Check if there are any pending changes.
     */
    AppearancePendingChanges.prototype.isEmpty = function () {
        return !Object.keys(this.changes).length;
    };
    /**
     * If there are any unsaved changes, confirm if user wants to leave the page.
     */
    AppearancePendingChanges.prototype.canDeactivate = function () {
        var _this = this;
        if (this.isEmpty())
            return true;
        return new Promise(function (resolve) {
            _this.modal.show(ConfirmModalComponent, {
                title: 'Close Appearance Editor',
                body: 'Are you sure you want to close appearance editor?',
                bodyBold: 'All unsaved changes will be lost.',
                ok: 'Close',
                cancel: 'Stay',
            }).afterClosed().subscribe(function (confirmed) {
                resolve(confirmed);
            });
        });
    };
    AppearancePendingChanges.ngInjectableDef = i0.defineInjectable({ factory: function AppearancePendingChanges_Factory() { return new AppearancePendingChanges(i0.inject(i1.AppHttpClient), i0.inject(i2.Toast), i0.inject(i3.Modal)); }, token: AppearancePendingChanges, providedIn: "root" });
    return AppearancePendingChanges;
}());
export { AppearancePendingChanges };
